<template>
  <div
    class="question-icon"
    :class="{ 'has-tooltip': this.withTooltip }"
    @click="$emit('onClick')"
  >
    ?
    <div class="tooltip" v-if="withTooltip">
      <slot>
        Mer info
      </slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'QuestionIcon',
  props: {
    withTooltip: {
      type: Boolean,
      default: true,
    },
  },
};
</script>

<style scoped>
@keyframes question-icon-bounce {
  from {
  }
  to {
    transform: translateY(-1rem);
  }
}

.question-icon.has-tooltip {
  animation: question-icon-bounce 0.5s ease 4 alternate;
}

.question-icon {
  border: 0.1rem solid #003451;
  border-radius: 50% 50% 50% 0;
  height: 2rem;
  width: 2rem;
  line-height: 2rem;
  text-align: center;
  font-size: 18px;
  display: inline-block;
  top: -0.5rem;
  position: relative;
  cursor: pointer;
  box-shadow: 0 5px 5px 0px rgba(0, 0, 0, 0.4);
}

.tooltip {
  background-color: black;
  color: #fff;
  text-align: center;
  border-radius: 0rem;
  padding: 0.5rem 1rem;
  position: absolute;
  z-index: 1;
  bottom: 3rem;
  font-size: 12px;
  opacity: 0;
  animation: tooltip-fade-out 6s linear 0s;
  white-space: nowrap;
  left: 50%;
  transform: translateX(-50%);
  line-height: 1.5;
}

.tooltip::after {
  content: '';
  position: absolute;
  top: 100%;
  left: 50%;
  margin-left: -5px;
  border-width: 5px;
  border-style: solid;
  border-color: black transparent transparent transparent;
}

@keyframes tooltip-fade-out {
  0% {
    opacity: 0;
  }
  50% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}
</style>
